'use strict';

// import * as d3 from 'd3';

export const renderLegend = (container, data, options) => {
  const itemPosX = (options.position && options.position.x) ? options.position.x : 0;
  const itemPosY = (options.position && options.position.y) ? options.position.y : 0;
  const itemWidth = (options.itemSize && options.itemSize.width) ? options.itemSize.width : 10;
  const itemHeight = (options.itemSize && options.itemSize.height) ? options.itemSize.height : 10;
  const fontSize = (options.font && options.font.size) ? options.font.size : 10;
  const fontFamily = (options.font && options.font.family) ? options.font.family : 'sans-serif';
  const hasTitle = options.title !== undefined;
  const isHorizontal = options.isHorizontal ? options.isHorizontal : false;
  const chartWidth = options.chartWidth ? options.chartWidth : undefined;
  const legendItemsOffset = hasTitle ? fontSize : 0;
  const legendContainer = container.append('g')
    .attr('class', 'legend-container')
    .attr('font-family', fontFamily)
    .attr('font-size', fontSize)
    .attr('text-anchor', 'start');

  if (hasTitle) {
    legendContainer
      .append('g')
      .attr('class', 'legend-title')
      .attr('transform', 'translate(0,0)')
      .append('text')
      .attr('class', 'legend-title')
      .attr('x', itemPosX)
      .attr('y', itemPosY)
      .attr('font-size', fontSize)
      .text(options.title);
  }
  const legendGroupEnter = legendContainer.selectAll('.legend-group')
    .data(data)
    .enter();

  const horizontalCheck = {
    startIndex: 0,
    rowIndex: 0
  };
  const legendGroup = legendGroupEnter.append('g')
    .attr('class', 'legend-group')
    .attr('transform', (d, i) => {
      if (isHorizontal) {
        let marginNeeded = 0;
        if (i > 0) {
          data.forEach((d2, i2) => {
            if (i2 < i && i2 >= horizontalCheck.startIndex) {
              marginNeeded = marginNeeded + ((data[i2].name.toString().length * 5) + 40);
            }
          });

          if (chartWidth && (marginNeeded > chartWidth * 0.9)) {
            marginNeeded = 0;
            horizontalCheck.rowIndex = horizontalCheck.rowIndex + 1;
            horizontalCheck.startIndex = i;
          }
        }
        const xTranslate = marginNeeded;
        const rowMargin = horizontalCheck.rowIndex * (itemHeight * 1.2) + legendItemsOffset;
        return `translate(${xTranslate}, ${rowMargin})`;
      } else {
        const yTranslate = i * (itemHeight * 1.1) + legendItemsOffset;
        return `translate(0, ${yTranslate})`;
      }
    });
  legendGroup.append('rect')
    .attr('class', 'legend-color')
    .attr('x', itemPosX)
    .attr('y', itemPosY)
    .attr('width', itemWidth)
    .attr('height', itemHeight)
    .attr('fill', d => d.color ? d.color : '#000000');
  legendGroup.append('text')
    .attr('class', 'legend-text')
    .attr('x', itemPosX + itemWidth + 5)
    .attr('y', itemPosY + 10)
    .attr('dy', '0.25rem') // Center of rectangle
    .attr('fill', '#333')
    .text(d => d.name);
};

const Legend = {
  renderLegend: renderLegend
};
export default Legend;
